/**
 * Store locator (new): region filters, scroll arrows, staggered card reveal,
 * and optional “Near you” sort using geolocation + per-store lat/long from the theme editor.
 */
(function () {
  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var toRadians = function (degrees) {
      return (degrees * Math.PI) / 180;
    };
    var R = 6371;
    var dLat = toRadians(lat2 - lat1);
    var dLon = toRadians(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function clearNearestState(container) {
    container.querySelectorAll('.store-locator-new__card--nearest').forEach(function (card) {
      card.classList.remove('store-locator-new__card--nearest');
    });
    container.querySelectorAll('.store-locator-new__nearest-badge').forEach(function (el) {
      el.remove();
    });
  }

  function hideHint(hintEl) {
    if (!hintEl) return;
    hintEl.textContent = '';
    hintEl.setAttribute('hidden', '');
  }

  function showHint(hintEl, message) {
    if (!hintEl || !message) return;
    hintEl.textContent = message;
    hintEl.removeAttribute('hidden');
  }

  function applyNearestBadge(card) {
    if (!card || card.querySelector('.store-locator-new__nearest-badge')) return;
    card.classList.add('store-locator-new__card--nearest');
    var badge = document.createElement('span');
    badge.className = 'store-locator-new__nearest-badge';
    badge.textContent = 'Near you';
    card.insertBefore(badge, card.firstChild);
  }

  function countCardsWithCoords(container) {
    var n = 0;
    container.querySelectorAll('.store-locator-new__card').forEach(function (card) {
      var lat = parseFloat(card.dataset.latitude);
      var lon = parseFloat(card.dataset.longitude);
      if (!Number.isNaN(lat) && !Number.isNaN(lon)) n += 1;
    });
    return n;
  }

  function sortVisibleByDistance(container, userLat, userLon, showBadge) {
    var grid = container.querySelector('.store-locator-new__grid');
    if (!grid) return false;

    var all = Array.prototype.slice.call(grid.querySelectorAll('.store-locator-new__card'));
    var visible = all.filter(function (c) {
      return !c.classList.contains('hidden');
    });
    var hidden = all.filter(function (c) {
      return c.classList.contains('hidden');
    });

    var withDistance = [];
    var withoutDistance = [];
    visible.forEach(function (card) {
      var lat = parseFloat(card.dataset.latitude);
      var lon = parseFloat(card.dataset.longitude);
      if (Number.isNaN(lat) || Number.isNaN(lon)) {
        withoutDistance.push(card);
      } else {
        withDistance.push({
          card: card,
          distance: getDistanceFromLatLonInKm(userLat, userLon, lat, lon),
        });
      }
    });

    if (!withDistance.length) return false;

    withDistance.sort(function (a, b) {
      return a.distance - b.distance;
    });
    clearNearestState(container);

    var sortedOrder = withDistance
      .map(function (x) {
        return x.card;
      })
      .concat(withoutDistance)
      .concat(hidden);
    sortedOrder.forEach(function (c) {
      grid.appendChild(c);
    });

    // Always track the globally nearest card so tab switches can reference it
    if (!container._nearestCard) {
      container._nearestCard = withDistance[0].card;
    }

    if (showBadge !== false) {
      applyNearestBadge(withDistance[0].card);
    }
    return true;
  }

  function requestNearestSort(container, hintEl, nearBtn) {
    hideHint(hintEl);
    clearNearestState(container);

    if (countCardsWithCoords(container) === 0) {
      showHint(
        hintEl,
        'No store coordinates yet. Add latitude and longitude to each store block in the theme editor.'
      );
      return;
    }

    if (!navigator.geolocation) {
      showHint(hintEl, 'This browser does not support location.');
      return;
    }

    function setLoading(on) {
      if (!nearBtn) return;
      nearBtn.classList.toggle('store-locator-new__near-btn--loading', on);
      nearBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function onError(error) {
      setLoading(false);
      var message = '';
      if (error && error.code === 1) {
        message =
          'Location is blocked for this site. Allow location in your browser’s site settings for this shop, then try again.';
      } else if (error && error.code === 2) {
        message = 'Your position could not be determined. Try again in a moment.';
      } else if (error && error.code === 3) {
        message = 'Location timed out. Check your connection and try again.';
      }
      if (message) showHint(hintEl, message);
    }

    function runGeo() {
      setLoading(true);
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setLoading(false);
          hideHint(hintEl);
          container.dataset.storeLocatorUserLat = String(position.coords.latitude);
          container.dataset.storeLocatorUserLon = String(position.coords.longitude);
          var ok = sortVisibleByDistance(
            container,
            position.coords.latitude,
            position.coords.longitude
          );
          if (!ok) {
            showHint(
              hintEl,
              'No coordinates on the stores shown. Add lat/long to those store blocks, or switch to “All locations”.'
            );
          }
        },
        onError,
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
      );
    }

    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then(function (result) {
          if (result.state === 'denied') {
            onError({ code: 1 });
            return;
          }
          runGeo();
        })
        .catch(function () {
          runGeo();
        });
    } else {
      runGeo();
    }
  }

  function initStoreLocatorNew(container) {
    if (!container) return;
    if (container.getAttribute('data-store-locator-initialized') === 'true') return;
    container.setAttribute('data-store-locator-initialized', 'true');

    var filterButtons = container.querySelectorAll('.store-locator-new__filter-btn');
    var storeCards = container.querySelectorAll('.store-locator-new__card');
    var filtersContainer = container.querySelector('.store-locator-new__filters');
    var leftArrow = container.querySelector('.store-locator-new__scroll-arrow--left');
    var rightArrow = container.querySelector('.store-locator-new__scroll-arrow--right');
    var hintEl = container.querySelector('[data-store-locator-location-hint]');
    var autoNearYou = container.getAttribute('data-auto-near-you') === 'true';

    function updateArrowVisibility() {
      if (!filtersContainer || !leftArrow || !rightArrow) return;

      var scrollLeft = filtersContainer.scrollLeft;
      var scrollWidth = filtersContainer.scrollWidth;
      var clientWidth = filtersContainer.clientWidth;
      var hasOverflow = scrollWidth > clientWidth + 1;
      var canScrollRight = scrollLeft < scrollWidth - clientWidth - 1;
      var canScrollLeft = scrollLeft > 1;

      if (!hasOverflow) {
        leftArrow.classList.remove('visible');
        rightArrow.classList.remove('visible');
        return;
      }

      leftArrow.classList.toggle('visible', canScrollLeft);
      rightArrow.classList.toggle('visible', canScrollRight);
    }

    function filterStores(region) {
      clearNearestState(container);
      hideHint(hintEl);

      storeCards.forEach(function (card) {
        var cardRegion = card.getAttribute('data-region');
        var normalizedRegion = region ? String(region).trim() : '';
        var normalizedCardRegion = cardRegion ? String(cardRegion).trim() : '';
        var shouldShow = normalizedRegion === 'all' || normalizedCardRegion === normalizedRegion;

        if (shouldShow) {
          card.classList.remove('hidden');
          card.classList.remove('no-js');
          card.classList.remove('visible');
        } else {
          card.classList.add('hidden');
          card.classList.remove('visible');
        }
      });

      var grid = container.querySelector('.store-locator-new__grid');
      if (grid) grid.offsetHeight;

      requestAnimationFrame(function () {
        storeCards.forEach(function (card) {
          if (!card.classList.contains('hidden')) {
            card.classList.add('visible');
          }
        });
        if (container.getAttribute('data-auto-near-you') === 'true') {
          var ulat = parseFloat(container.dataset.storeLocatorUserLat);
          var ulon = parseFloat(container.dataset.storeLocatorUserLon);
          if (!Number.isNaN(ulat) && !Number.isNaN(ulon)) {
            // Show badge only when the globally nearest card is visible in this tab
            var nearestCard = container._nearestCard;
            var showBadge = !nearestCard || !nearestCard.classList.contains('hidden');
            sortVisibleByDistance(container, ulat, ulon, showBadge);
          }
        }
      });
    }

    function setupFilters() {
      filterButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          var region = this.getAttribute('data-region');
          filterStores(region);
          filterButtons.forEach(function (b) {
            b.classList.remove('active');
            b.setAttribute('aria-selected', 'false');
          });
          this.classList.add('active');
          this.setAttribute('aria-selected', 'true');
        });
      });
    }

    function setupScrollArrows() {
      if (!leftArrow || !rightArrow || !filtersContainer) return;

      leftArrow.addEventListener('click', function (e) {
        e.preventDefault();
        filtersContainer.scrollBy({ left: -220, behavior: 'smooth' });
      });

      rightArrow.addEventListener('click', function (e) {
        e.preventDefault();
        filtersContainer.scrollBy({ left: 220, behavior: 'smooth' });
      });

      filtersContainer.addEventListener('scroll', updateArrowVisibility);
      window.addEventListener('resize', function () {
        setTimeout(updateArrowVisibility, 100);
      });
    }

    function showAllStores() {
      storeCards.forEach(function (card) {
        card.classList.remove('no-js');
      });
      setTimeout(function () {
        storeCards.forEach(function (card, index) {
          setTimeout(function () {
            card.classList.add('visible');
          }, index * 80);
        });
      }, 50);
    }

    setupFilters();
    setupScrollArrows();
    showAllStores();

    if (autoNearYou) {
      setTimeout(function () {
        requestNearestSort(container, hintEl, null);
      }, 500);
    }

    setTimeout(updateArrowVisibility, 100);
    setTimeout(updateArrowVisibility, 350);
    if (document.readyState === 'complete') {
      setTimeout(updateArrowVisibility, 500);
    } else {
      window.addEventListener('load', function () {
        setTimeout(updateArrowVisibility, 100);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[id^="store-locator-root-"]').forEach(function (root) {
      initStoreLocatorNew(root);
    });
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[id^="store-locator-root-"]');
    if (root) initStoreLocatorNew(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
